<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Indicadores — OS-m
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Em
        strong  Indicadores → OS-m
        |  há relatórios tabulares, gráficos e mapas sobre ordens de serviço.
        |  Cada card só aparece se você tiver a permissão correspondente.

      h5.h5 1. Abrir o hub
      ol
        li No menu lateral, abra
          strong  Indicadores
          | .
        li Clique em
          strong  OS-m
          | .
      figure.manual-figure
        img(:src="imgHub" alt="Hub de indicadores de OS-m")

      h5.h5 2. Relatório com gráfico e tabela
      ol
        li Abra um card (ex.:
          strong  Situações por meses
          | ).
        li Em
          strong  Filtrar
          | , ajuste o período e demais critérios.
        li Clique no ícone de
          strong  funil
          |  para aplicar e use a
          strong  impressora
          |  para imprimir.
        li Leia o gráfico e a tabela de totais.
      figure.manual-figure
        img(:src="imgReport" alt="OS-m Situações por meses")

      h5.h5 3. Mapas
      ol
        li Em
          strong  Pontos no mapa
          |  ou
          strong  Densidade no mapa
          | , filtre e aguarde o carregamento.
        li Nos pontos, clusters mostram a quantidade; zoom e clique abrem detalhes.
      figure.manual-figure
        img(:src="imgMapa" alt="OS-m Pontos no mapa")

      h5.h5 4. Relatórios do hub
      p Permissões no formato
        strong  Indicadores → Ordem serviços → …
        | :
      ul
        li
          strong  Situações por meses
          |  — quantidade mensal por situação.
          |  Permissão:
          strong  Situações por meses
          | .
        li
          strong  Por assunto
          |  — quantidade mensal por assunto.
          |  Permissão:
          strong  Assuntos
          | .
        li
          strong  Por Grupo
          |  — quantidade por grupo.
          |  Permissão:
          strong  Grupos
          | .
        li
          strong  Por fiscal e meses
          |  /
          strong  Por fiscal e dias
          |  — quantidade por fiscal.
          |  Permissões:
          strong  Fiscais por meses
          |  /
          strong  Fiscais por dias
          | .
        li
          strong  Por fiscais Andamento/Distribuição
          |  — andamento e distribuição por fiscal.
          |  Permissão:
          strong  Fiscais andamento distribuição
          | .
        li
          strong  Por zona
          |  — quantidade mensal por zona.
          |  Permissão:
          strong  Zonas
          | .
        li
          strong  Por assunto/fiscal
          |  — cruzamento assunto e fiscal.
          |  Permissão:
          strong  Fiscais por assuntos
          | .
        li
          strong  Tempo médio por assunto
          |  /
          strong  Tempo médio por fiscal
          |  — média de tempo para concluir.
          |  Permissões:
          strong  Tempo médio por assuntos
          |  /
          strong  Tempo médio por fiscais
          | .
        li
          strong  Pontos no mapa
          |  /
          strong  Densidade no mapa
          |  — localização e incidência.
          |  Permissões:
          strong  Mapas → Pontos
          |  /
          strong  Densidade
          | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgHub: require("@/assets/manuais/30-indicadores-osm-hub.png"),
      imgReport: require("@/assets/manuais/30a-indicadores-osm-situacoes-mes.png"),
      imgMapa: require("@/assets/manuais/30b-indicadores-osm-mapa-pontos.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px
</style>
